import { Item } from './item';

export const MOCKITEMS: Item[] = [
  {
    title: 'Battery powered',
    image: 'http://hgcdn82.azureedge.net/qs_mh=680&mw=680&ver=00000000T000000&hcsh=722CDBEAA139ED8D34A28F73AF01EF8E5E2B5E70/_$$_/media/dam/husqvarna/garden%20lawnmowers%20and%20ride-on%20mowers/tractors/2014/12/08/23/26/h310-0483.ashx',
    market: 'incremental',
    technology: 'incremental',
    description: 'Improved battery life expectancy of lawn mowers',
  }, {
    title: 'Robotic',
    image: 'http://hgcdn82.azureedge.net/qs_mh=680&mw=680&ver=00000000T000000&hcsh=58863C18DCFBE07776DC9DF6C38D3328487CF0A4/_$$_/media/dam/husqvarna/garden%20lawnmowers%20and%20ride-on%20mowers/robotic%20lawnmowers/2015/06/24/17/56/h310-1176.ashx',
    market: 'incremental',
    technology: 'disruptive',
    description: 'Battery driven robotic lawn mower',
  }, {
    title: 'Solar powered',
    image: 'https://cnet4.cbsistatic.com/img/es4SP4DGLd3mkzmCznnhg9pd2NU=/fit-in/970x0/2008/10/23/62ac9435-f4d6-11e2-8c7c-d4ae52e62bcc/Husqvarna_Solar_Hybrid_robot_mower.jpg',
    market: 'incremental',
    technology: 'breakthrough',
    description: 'Solar powered robotic lawn mower',
  }, {
    title: 'Community programme',
    image: 'http://hgcdn82.azureedge.net/qs_h=700&crop=1&w=1470&ver=00000000T000000&hcsh=B0634860DD7A4642F193D44D0B3593F21296B714/_$$_/media/dam/husqvarna/garden%20lawnmowers%20and%20ride-on%20mowers/riders/2014/12/09/03/21/h320-0260.ashx',
    market: 'disruptive',
    technology: 'incremental',
    description: 'Community lawn mower sharing programme',
  }, {
    title: 'Community application',
    image: 'https://cnet1.cbsistatic.com/img/rig0krCzl0qq9YBlR5KWLuV3t5s=/936x527/2011/04/12/2432696c-cbf2-11e2-9a4a-0291187b029a/p1050398.jpg',
    market: 'disruptive',
    technology: 'disruptive',
    description: 'Community lawn mower sharing application',
  }, {
    title: 'Community robot',
    image: 'https://i.ytimg.com/vi/XwuNoTnn5gs/hqdefault.jpg',
    market: 'disruptive',
    technology: 'breakthrough',
    description: 'City lawn mower sharing application with robotic lawn mowers',
  }, {
    title: 'Battery Research programme',
    image: 'https://news.uci.edu/wp-content/uploads/2016/04/nanowires_160420_01_sz_small.jpg',
    market: 'breakthrough',
    technology: 'incremental',
    description: 'Collaborative research programme into battery life expectancy',
  }, {
    title: 'Solar powered reserach programme',
    image: 'https://inhabitat.com/files/babcock-ed01.jpg',
    market: 'breakthrough',
    technology: 'disruptive',
    description: 'Collaborative research programme into solar power',
  }, {
    title: 'Biodegradable lawn mowers',
    image: 'http://www.materialsforengineering.co.uk/article-images/74815/bio_popup.jpg',
    market: 'breakthrough',
    technology: 'breakthrough',
    description: 'Wrokign with startups on biodegradable lawn mowers to get them to market quick',
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/transition-matrix/items/mock-items.ts